import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">Start Searching Now. Get the App.</h2>
          <div className="cta-badges">
            <a 
              href="https://play.google.com/store/apps" 
              className="cta-badge"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Get it on Google Play"
                className="badge-image"
              />
            </a>
            <a 
              href="https://www.apple.com/app-store/" 
              className="cta-badge"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1276560000" 
                alt="Download on the App Store"
                className="badge-image"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;

